const apiCallTypeCreator = prefix => ({
	REGULAR: prefix,
	SUCCESS: `${prefix}_SUCCESS`
});

export default apiCallTypeCreator;
